(() => {
  if(!customElements.get('product-price')){
    class ProductPrice extends HTMLElement{
      constructor(){
        super();
        this.InitWatchers();
      }
      InitWatchers() {
        let $form = this.closest('.product-form');
        if (!$form) return;
        console.log($form);
        let variants_prices = JSON.parse(this.dataset.variants_prices);
        let price_format = this.dataset.price_format;
        let events = ['change', 'click'];
        events.forEach(event_type => {
          $form.addEventListener(event_type, (e) => {
            let $id = $form.querySelector('input[name="id"]');
            let variant = variants_prices.find(v => v.id == $id.value);
            let $price = $form.querySelector('[data-price]');
            let $compare_price = $form.querySelector('[data-compare_at_price]')
            $price.textContent = price_format == 'with_currency' ? variant.price : variant.price_no_currency;
            $compare_price.textContent = price_format == 'with_currency' ? variant.compare_at_price : variant.compare_at_price_no_currency;

            $compare_price.classList.toggle('hidden', (!variant.compare_at_price || !variant.compare_at_price_no_currency));
            console.log(e, variant);
          });
        });
      }
    }
    customElements.define('product-price', ProductPrice);
  }
})();
